module.exports = __webpack_public_path__ + "img/google_logo.ed15b880.svg";